import script from "./ExRegmani.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExRegmani.vue?vue&type=script&setup=true&lang=ts"

import "./ExRegmani.vue?vue&type=style&index=0&id=adecd8ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adecd8ac"]])

export default __exports__